export const SERVICE = 'service'
export const INTERNAL = 'internal'
export const DYNAMIC = 'dynamic'
